import { useState, useEffect } from "react";
import { Button, Modal, Form, Select } from "antd";
import { useGetUsersQuery } from "../../redux/services/userApi";

const { Option } = Select;

const TransferBookingsModal = (props: any) => {
  const { isModalOpen, user, onCancel, onTransfer } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { data: cityManagerData } = useGetUsersQuery({
    role_type: "city_manager",
    all_pages: true
  });
  const cityManagers = cityManagerData?.users.filter((u: any) => u.id !== user.id) || [];

  const onFinish = (values: any) => {
    const params = { userId: user?.id, roleData: { user: values } };
    onTransfer(params, setLoading, form);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    return () => {
      form.resetFields();
    };
  }, [isModalOpen]);

  return (
    <Modal
      title="Transfer Bookings"
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
      destroyOnClose
    >
      <Form
        name="transfer_bookings_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="city_manager_id"
          label="City Manager"
          rules={[{ required: true, message: "Please select city manager" }]}
        >
          <Select
            placeholder="Select city manager"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {cityManagers.map((cityManager: any) => <Option key={cityManager.id} value={cityManager.id}>{`${cityManager.name} - ${cityManager.mobile}`}</Option>)}
          </Select>
        </Form.Item>


        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Transfer
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TransferBookingsModal;
